import { Component, inject, Input } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs/operators";
import { KENDO_BREADCRUMB } from "@progress/kendo-angular-navigation";

import { AppBreadCrumbItem, BreadcrumbService } from "../services/breadcrumb.service";
import { MenuNode, menuyItems } from "./menuItems"; // ajusta la ruta real
import { AuthService } from "../auth.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"],
  standalone: true,
  imports: [RouterOutlet, KENDO_BREADCRUMB],
})
export class MenuComponent {
  private router = inject(Router);
  private breadcrumbService = inject(BreadcrumbService);
  private auth = inject(AuthService);

  @Input() public selected = "home";

  public breadcrumbItems = this.breadcrumbService.breadcrumbItems;

  private readonly root: MenuNode = menuyItems as MenuNode;

  constructor() {
    // ✅ 1) al cargar (refresh / URL directa)
    this.breadcrumbService.syncFromUrl(this.router.url, this.root);

    // ✅ 2) en cada navegación (incluye navegar por links normales)
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.breadcrumbService.syncFromUrl(e.urlAfterRedirects, this.root);
      });
  }

  // ✅ Click en breadcrumb: navega y el servicio se actualiza solo por NavigationEnd
  public onItemClick(e: any): void {
    // Kendo emite un item sin tu typing, lo casteamos
    const clicked = (e?.item ?? e) as unknown as AppBreadCrumbItem;
    if (!clicked) return;

    // si el item tiene path, navega directo
    if (clicked.path) {
      this.router.navigateByUrl(clicked.path);
      return;
    }

    // fallback: si no hay path, intenta resolver por textName
    if (clicked.textName) {
      

      // opcional: navegar al nodo si tiene path
      const node = this.findNodeByTextName(this.root, clicked.textName);
      if (node?.path) {
        this.breadcrumbService.updateBreadcrumbFromTree(this.root, clicked.textName);
        this.router.navigateByUrl(node.path);
      }
    }
  }

  private findNodeByTextName(root: MenuNode, textName: string): MenuNode | null {
    const stack: MenuNode[] = [root];
    while (stack.length) {
      const cur = stack.pop()!;
      if (cur.textName === textName) return cur;

      const children = cur.children ?? [];
      for (let i = children.length - 1; i >= 0; i--) stack.push(children[i]);
    }
    return null;
  }

  public logout(): void {
    this.auth.logoutRedirect();
  }
}
